import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { LEFTRIGHT_PADDING } from "../config/style.config";
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import WhiteCloseSvg from '../svgs/WhiteCloseSvg'
import GenerateForm from '../components/permit/display/GenerateForm';
import FormStatus from '../components/riskAssessment/display/FormStatus';
import Loading from '../components/Loading'
import ActivityLog from '../components/riskAssessment/ActivityLog';
import { getDateOnly } from '../actions/actionsDateTime'
import { deleteFileByName } from '../services/httpApiTracking';
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf";
import { THEMES } from '../dto/theme';
import LoadingPage from '../components/Loading';
import { fetchRiskAssessmentTemplateList, postRiskAssessmentHistory, postRiskAssessmentTemplateDocument } from '../services/riskAssessments.service';
import { fetchWorkOrderById, postCreateWorkOrder, putEditWorkOrder } from '../services/workOrders.service';
import { RISKASSESSMENT_DEFAULT_TYPE } from '../config';
function Screen(props) {
    const navigate = useNavigate();
    const param = useLocation()
    const URLParam = useParams()

    const currentUserId = props.control.userData._id
    if (!param.state?.data && !URLParam._id) navigate('/risk-assessment')
    const [templateData, setTemplateData] = useState({})
    const [formData, setFormData] = useState(param?.state?.data?.form)
    const [copyTemplate, setCopyTemplate] = useState({ ...param?.state?.data })
    const [editedObj, setEditedObj] = useState({})
    const [attachments, setAttachements] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [pageToggle, setPageToggle] = useState('Overview')
    const [userIsIssuer, setIsUserIssuer] = useState(undefined)
    const [userIsApprover, setIsUserApprover] = useState(undefined)
    const [userIsReceiver, setIsUserReceiver] = useState(undefined)
    const [hasPermission, setHasPermission] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')

    useEffect(() => {
        // set permission
        if (props.control.userData?._id && templateData.createdBy && !hasPermission) {
            const issuerPermission = props.control.userData._id === templateData.createdBy
            const approvePermission = (templateData?.approvers || []).some((obj) => obj.username === props.control.userData.username)
            const viewPermission = (templateData?.viewers || []).some((obj) => obj.username === props.control.userData.username)
            setIsUserIssuer(issuerPermission)
            setIsUserApprover(approvePermission)
            setIsUserReceiver(viewPermission)
            const havePerm = [issuerPermission, approvePermission, viewPermission].some((perms) => perms === true)
            setHasPermission(havePerm)
        }
    }, [props.control.userData, templateData])

    // useEffect(() => {
    //     console.log('editObj',editedObj)
    // },[editedObj])
    useState(async () => {
        let forms = param?.state?.data
        let temp = {
            form: forms || [],
            isEmergency: param?.state?.isEmergency || false,
            createdBy: param?.state?.createdBy || null,
        }

        if (URLParam._id) {
            const newTemplateData = await fetchWorkOrderById(props.token.token, URLParam._id)
            if (newTemplateData.errno) return navigate('/risk-assessment/work-order')
            temp = { ...newTemplateData.result }
        }

        if (!temp.approvers) temp.approvers = []
        if (!temp.receivers) temp.receivers = []
        if (!temp.viewers) temp.viewers = []
        temp.newAttachments = []
        temp.newDelete = []
        temp.template_id = `${Date.now()}`
        setCopyTemplate({ ...temp })
        setTemplateData(temp)
        setFormData(temp.form)
    }, [param?.state])
    function handleSubmitError(msg) {
        setErrorMsg(msg)
        setIsLoading(false)
    }
    async function sumbitData() {
        const finalData = { ...templateData }
        finalData.form = [...formData]
        finalData.projectId = props.control.projectId
        // return compareForHistory(finalData)
        if (!finalData.name || finalData.name.trim() === '') return handleSubmitError('Input Work Order Name');
        if (finalData.attachments === undefined) finalData.attachments = []
        if (finalData.isAllApprovers === undefined) finalData.isAllApprovers = false
        if (finalData?.status === undefined) return handleSubmitError('Pick a status');
        if (finalData.validFrom === undefined || finalData.validTo === undefined) return handleSubmitError('Input valid time');
        if (!finalData.validFrom instanceof Date && !isNaN(finalData.validFrom)) return handleSubmitError('invalid validFrom date formate')
        if (!finalData.validTo instanceof Date && !isNaN(finalData.validTo)) return handleSubmitError('invalid validTo date formate')
        //
        delete finalData._id
        delete finalData.type
        const copyNewAttachement = [...finalData.newAttachments]
        finalData.attachments = [...finalData.attachments, ...finalData.newAttachments]
        delete finalData.newAttachments
        setIsLoading(true)
        let assessmentRes
        if (finalData.newDelete.length > 0) {
            finalData.newDelete.forEach(async ({ id, type }) => {
                const res = await deleteFileByName(props.token.token, id + '.' + type.split('/')[1])
            })
        }
        delete finalData.newDelete
        delete finalData.createdById
        delete finalData.createdByUser
        delete finalData.createdBy
        delete finalData.modifiedBy
        delete finalData.createDate
        delete finalData.modifyDate
        if (URLParam._id) {
            delete finalData.projectId
            delete finalData.template_id
            assessmentRes = await putEditWorkOrder(props.token.token, finalData, templateData._id)
            const history = compareForHistory(finalData)
            console.log(history)
            const historyRes = await handlePostHistory(history)
        } else {
            assessmentRes = await postCreateWorkOrder(props.token.token, finalData)
            const createFirst = await handlePostHistory({ created: '' }, assessmentRes.result.insertedId)
            console.log('called handlePostHistory')
        }
        if (assessmentRes.errno) {
            alert('Error occurred: ' + assessmentRes.message)
            setIsLoading(false)
            return console.log(assessmentRes)
        }
        //
        // console.log('copy new Attach', copyNewAttachement)
        if (copyNewAttachement.length > 0) {
            let i = 0
            for (const file of attachments.entries()) {
                const id = copyNewAttachement[i].id
                const type = copyNewAttachement[i].type
                const res = await postRiskAssessmentTemplateDocument(props.token.token, file, id, type)
                if (res.errno) return console.log(res)
                i++
            }
        }

        setIsLoading(false)
        navigate('/risk-assessment/work-order')
    }
    function handleHaveAttachement(formData) {
        setAttachements(formData)
    }
    function updateFieldDataDataWithKey(i, k, val) {
        console.log(selectedForm)
        const newFormsArray = [...formData]
        const temp = newFormsArray?.[selectedForm]?.form || []
        const newEditedObj = { ...editedObj }
        const title = temp[i].data[k].fieldData.title === undefined ? temp[i].data[k].fieldData.textInputTitle : temp[i].data[k].fieldData.title
        const newKey = `Form_${selectedForm}_Section${i + 1}_${temp[i].data[k].type}_${title}`
        newEditedObj[newKey] = [val]
        temp[i].data[k].fieldData.data = val
        setEditedObj(newEditedObj)
        setFormData(newFormsArray)
        console.log(newFormsArray)
    }
    function updateFieldData(i, k, val) {
        const newFormsArray = [...formData]
        const temp = newFormsArray?.[selectedForm]?.form || []
        const newEditedObj = { ...editedObj }
        const type = temp[i].data[k].type
        const newKey = `Form_${selectedForm}_Section${i + 1}_${type}_field${k + 1}`
        newEditedObj[newKey] = 'Updated value'
        temp[i].data[k].fieldData = val
        setEditedObj(newEditedObj)
        setFormData(newFormsArray)
        console.log(newFormsArray)
    }
    function handleDeleteExistingFile(obj) {
        const temp = { ...templateData }
        const copy = [...templateData.attachments]
        const final = copy.filter(({ id, type }) => id !== obj.id)
        const deleteArr = copy.filter(({ id, type }) => id === obj.id)
        const newDelete = [...templateData.newDelete, ...deleteArr]
        temp.newDelete = newDelete
        temp.attachments = final
        //
        const newEditedObj = { ...editedObj }
        const type = 'remove_attachment'
        const newKey = `${type}_${obj.id + '.' + obj.type.split('/')[1]}`
        newEditedObj[newKey] = ''
        setEditedObj(newEditedObj)
        setTemplateData(temp)
    }
    function updateTemplateDataWithKey(key, val) {
        const temp = { ...templateData }
        const newEditedObj = { ...editedObj }
        const newKey = `Permit_${key}`
        if (['validFrom', 'validTo'].includes(key)) {
            newEditedObj[newKey] = [getDateOnly(val)]
        }
        temp[key] = val
        if (key === 'newAttachments') {
            const type = 'permit_newAttachement'
            newEditedObj[type] = ''
        }
        setEditedObj(newEditedObj)
        setTemplateData(temp)
    }
    async function handlePostHistory(obj, whenCreate = null) {
        const data = {}
        data.riskAssessment_id = templateData._id
        if (whenCreate) data.riskAssessment_id = whenCreate
        data.data = obj
        const res = await postRiskAssessmentHistory(props.token.token, data)
    }
    function compareForHistory(newObj) {
        const historyObj = { ...editedObj }
        if (copyTemplate.status !== newObj.status) historyObj.status = templateData.status
        const usersAll = ['approvers', 'receivers', 'viewers']
        usersAll.forEach(key => {
            const idToApprove = {}
            const ogUser = copyTemplate[key].map(obj => {
                if (key === 'approvers') idToApprove[obj.username] = obj.isApproved
                if (key === 'receivers') idToApprove[obj.username] = obj.isRead
                return obj.username
            })
            const userSet = new Set(ogUser)
            console.log(idToApprove, userSet)
            newObj[key].forEach(obj => {
                console.log(obj)
                if (!userSet.has(obj.username)) {
                    const objKey = 'added_' + key
                    historyObj[objKey] ? historyObj[objKey].push(obj.username) : historyObj[objKey] = [obj.username]
                } else {
                    if (key === 'approvers') {
                        if (idToApprove[obj.username] !== obj.isApproved) {
                            historyObj.newlyApproved ? historyObj.newlyApproved.push(obj.username) : historyObj.newlyApproved = [obj.username]
                        }
                    }
                    if (key === 'receivers') {
                        if (!idToApprove[obj.username] === obj.isRead) {
                            historyObj.newlyRead ? historyObj.newlyRead.push(obj.username) : historyObj.newlyRead = [obj.username]
                        }
                    }
                    userSet.delete(obj.username)
                }
            })
            const remaining = Array.from(userSet)
            if (remaining.length > 0) {
                remaining.forEach((user) => {
                    const newKey = 'removed_' + key
                    historyObj[newKey] ? historyObj[newKey].push(user) : historyObj[newKey] = [user]
                })
            }
        })
        console.log(historyObj)
        return {
            data: historyObj
        }
    }
    function handleUpdateRoles(type, obj) {
        const currentList = [...templateData[type]]
        let targetDeleteIdx = undefined
        const inCurrentList = currentList.some((currObj, idx) => {
            const result = currObj.username === obj.username
            if (result) targetDeleteIdx = idx
            return result
        })
        if (inCurrentList) {
            currentList.splice(targetDeleteIdx, 1)
        } else {
            let tempObj = undefined
            if (type === 'approvers') tempObj = { username: obj.username, isApproved: -1 }
            if (type === 'viewers') tempObj = { username: obj.username }
            currentList.push(tempObj)
        }
        updateTemplateDataWithKey(type, currentList)
    }


    const divToPrintRef = useRef(null)
    const downloadReport = async () => {
        if(isLoading)return
        setIsLoading(true)
        let doc = new jsPDF('p', 'mm', 'a4', true);

        let page =1;
        const arr=[]

        const d = divToPrintRef.current;

        const canvas = await html2canvas(d,{useCORS:true})
        const img= canvas.toDataURL('image/png');

        console.log('generated image for page: ', page)
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        arr.push([img, 'PNG', 0, position, imgWidth, imgHeight])
        page++

        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            arr.push([img, 'PNG', 0, position, imgWidth, imgHeight])
            heightLeft -= pageHeight;
            console.log('generated image for page: ', page, 'heightLeft:',heightLeft)
            page++
        }


        for(let i in arr){
            console.log('adding page: ', i)
            doc.addImage(arr[i][0], 'PNG', 0, arr[i][3], arr[i][4], arr[i][5], i, "SLOW");
            if(i!=(arr.length-1))
                doc.addPage();
        }
        console.log(arr)

        doc.save('risk-assessment.pdf');
        setIsLoading(false)
     };


    const [selectedForm, setSelectedForm] = useState(0)
    const [filterType, setFilterType] = useState('All')
    const [templateListData, setTemplateListData] = useState([])
    const [showSelectTemplatePopup, setShowSelectTemplatePopup] = useState(false)
    useEffect(() => {
        fetchTemplateData()
    }, [filterType])
    async function fetchTemplateData() {
        const filter = {}
        if (filterType !== 'All') filter['type'] = { "$eq": `${filterType}` }
        filter.projectId = props.control.projectId
        const res = await fetchRiskAssessmentTemplateList(props.token.token, filter, {})
        if (res.errno) return console.log('error fetching data')

        setTemplateListData(res.result)
    }
    function handleSelectedTemplate(obj) {
        let newSelected = [...formData]
        //push new obj by copy not by reference, including nested array
        newSelected.push(JSON.parse(JSON.stringify(obj)))
        setFormData(newSelected)
    }

    return (
        <div className='w-full h-full pb-12' style={{ overflowY: 'auto', filter: props.control.theme === THEMES.DARK ? 'none' : 'invert(1)', color: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000', backgroundColor: props.control.theme === THEMES.DARK ? '#0C0D14' : '#FFFFFF' }}>
            {isLoading && <div className='select-none opacity-40 w-[100vw] h-[100vh] fixed inset-0 bg-[#000000] flex flex-row items-center justify-center' style={{ zIndex: 99 }}>
                <Loading />
            </div>}
            <div style={{ ...LEFTRIGHT_PADDING, backgroundColor: props.control.theme === THEMES.DARK ? '#0C0D14' : '#FFFFFF' }} className='flex flex-col' ref={divToPrintRef}>
                <div className="flex flex-col justify-between items-center text-white">
                    <div className="flex flex-row items-center justify-between mt-[40px] w-full flex-wrap">
                        <div className='flex flex-row items-center flex-1 min-w-[300px]'>
                            <TitleLeftSvg className='mr-[9px]' />
                            <div className="text-[24px] font-bold flex-1" style={{ color: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000' }}>
                                Preview - <input type='text' value={templateData?.name || ''} onChange={(e) => updateTemplateDataWithKey('name', e.target.value)} placeholder='Work Order Name' className='bg-transparent focus:outline-none' style={{ borderBottom: '1px solid', borderBottomColor: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000', color: props.control.theme === THEMES.DARK ? '#FFFFFF' : '#000000', maxWidth: '300px' }} />
                            </div>
                        </div>
                        <div className='flex flex-row items-center justify-center gap-4 flex-wrap'>
                            <div onClick={() => navigate('/risk-assessment/work-order')} className='py-[2px] px-[16px] text-white rounded-full select-none cursor-pointer' style={{ backgroundColor: props.control.theme === THEMES.DARK ? '#FFFFFF26' : '#000000' }}>
                                Cancel</div>
                            {(hasPermission || props.token?.usertype === 'admin') && <div onClick={() => { sumbitData() }} className='py-[2px] px-[16px] bg-[#00202A] text-[#63BDFF] rounded-full select-none cursor-pointer'>{URLParam._id ? 'Save Work Order' : 'Create Work Order'}</div>}
                        </div>
                    </div>
                    <div className='text-[red] ml-auto'>{errorMsg}</div>

                </div>
                <div className='w-full flex flex-row mt-[40px] flex-wrap gap-[16px]'>
                    <div className='flex-1'>
                        <div className='w-full flex flex-row'>
                            <div onClick={() => { setPageToggle('Overview') }} className='p-[8px] select-none cursor-pointer text-[16px] font-bold' style={pageToggle === 'Overview' ? { borderBottomWidth: 1, borderBottomColor: '#FFFFFF80', color: props.control.theme === THEMES?.DARK ? 'white' : 'black' } : { color: props.control.theme === THEMES?.DARK ? '#3F3F3F' : 'grey' }}>Overview</div>
                            <div onClick={() => { setPageToggle('Activity Log') }} className='p-[8px] select-none cursor-pointer text-[16px] font-bold' style={pageToggle === 'Activity Log' ? { borderBottomWidth: 1, borderBottomColor: '#FFFFFF80', color: props.control.theme === THEMES?.DARK ? 'white' : 'black' } : { color: props.control.theme === THEMES?.DARK ? '#3F3F3F' : 'grey' }}>Activity Log</div>
                        </div>
                        {pageToggle === 'Overview' && <div className='flex-1 max-w-[1500px] relative flex flex-col'>
                            <div className='w-full flex flex-row mt-[8px] flex-wrap max-w-[1500px] items-center'>
                                {formData?.length > 0 && formData?.map((formObj, i) =>
                                    <div key={i} onClick={() => setSelectedForm(i)} className={`cursor-pointer select-none py-[4px] px-[12px] border ${props.control.theme === THEMES.DARK ? 'border-[#ffffff80]' : 'border-[#000]'} rounded-b-none min-w-[200px]`} style={i === selectedForm ? { backgroundColor: '#00202A', color: '#63BDFF', fontWeight: 'bold' } : { backgroundColor: props.control.theme === THEMES.DARK ? '#363636B2' : '#FFFFFF', color: props.control.theme === THEMES.DARK ? '#FFFFFF80' : '#00000080' }}>
                                        {formObj.name || `${i + 1}`}
                                    </div>
                                )}
                                {/* edit form button */}
                                <div onClick={() => { setShowSelectTemplatePopup(true) }} className='cursor-pointer select-none py-[4px] px-[12px]' style={{ color: props.control.theme === THEMES.DARK ? 'white' : 'black' }}>
                                    + Add Form
                                </div>
                            </div>
                            <GenerateForm formIndex={selectedForm} inPending={templateData.status === 'Pending for approval'} permissionObj={{ userIsIssuer, userIsApprover, userIsReceiver }} form={formData?.[selectedForm]?.form} isPreview={false} updateFieldDataDataWithKey={updateFieldDataDataWithKey} updateFieldData={updateFieldData} />
                        </div>}
                        {(pageToggle === 'Activity Log' && URLParam._id) && <ActivityLog hasPermission={hasPermission || props.token?.usertype === 'admin'} handlePostHistory={handlePostHistory} _id={templateData._id} />}
                    </div>
                    <div className='flex-1 h-full py-[24px] px-[20px]' style={{ maxWidth: 'min(400px, 100%)' }}>
                        <FormStatus isWorkOrder={true} hasPermission={hasPermission || props.token?.usertype === 'admin'} handleUpdateRoles={handleUpdateRoles} handleDeleteExistingFile={handleDeleteExistingFile} handleHaveAttachement={handleHaveAttachement} templateData={templateData} updateTemplateDataWithKey={updateTemplateDataWithKey} isPreview={false} />
                    </div>
                </div>
                <div onClick={downloadReport} className='cursor-pointer underline mb-[20px]' style={{padding:'4px 12px'}}>Download Risk Assessment</div>
            </div>

            {showSelectTemplatePopup &&
                <div className='fixed inset-0 w-[100vw] h-[100vh] bg-[#000000B2] flex flex-row items-center justify-center' style={{ zIndex: 98 }}>
                    <div className="w-[35%] max-w-[95%] max-h-[80%] min-h-[646px] border border-[#FFFFFF80] rounded bg-[#363636B2] p-[40px] text-white flex flex-col" style={{ zIndex: 99, minWidth: 'min( 850px , 100% )' }}>
                        <div className="flex flex-row justify-between mb-8">
                            <div className="text-[18px] font-bold">Select Template</div>
                            <WhiteCloseSvg className='cursor-pointer' onClick={() => { setShowSelectTemplatePopup(false) }} />
                        </div>
                        <div className='flex flex-row items-center flex-wrap'>
                            {['All', ...RISKASSESSMENT_DEFAULT_TYPE].map((type) => <div key={type} onClick={() => setFilterType(type)} className='p-[8px] text-nowrap flex-1 cursor-pointer select-none' style={filterType === type ? { borderBottomColor: 'white', borderBottomWidth: 1 } : { borderBottomColor: '#FFFFFF80', borderBottomWidth: 1 }}>
                                {type}
                            </div>)}
                        </div>

                        <div className='w-full flex-1 overflow-y-scroll mt-[32px] flex-1'>
                            {templateListData.length > 0 && templateListData.map((assessmentObj, i) => <div key={assessmentObj._id} className='flex flex-row items-center mb-[16px] gap-[16px]'>
                                <div className='border-white border-[1px] w-[24px] h-[24px] rounded-[12px] hover:opacity-[.5] flex justify-center items-center cursor-pointer' onClick={() => handleSelectedTemplate(assessmentObj)} >
                                    <div className='font-[700] mt-[-1px] mr-[-1px]'>+</div>
                                </div>
                                <div>{assessmentObj.name} <span className='text-[#949494]'>| {assessmentObj.templateType || assessmentObj?.type}</span></div>
                            </div>)}
                        </div>
                        <div className="text-[18px] font-bold mt-[24px] w-full" style={{ borderBottom: '.5px solid white' }}>Selected Forms</div>
                        <div className='w-full flex-1 overflow-y-scroll mt-[8px] flex-1'>
                            {formData.length > 0 && formData.map((assessmentObj, i) =>
                                <div key={i} className='flex flex-row items-center mb-[16px] gap-[16px]'>
                                    <div className='border-white border-[1px] w-[24px] h-[24px] rounded-[12px] hover:opacity-[.5] flex justify-center items-center cursor-pointer' onClick={() => {
                                        let newSelected = [...formData]
                                        newSelected.splice(i, 1)
                                        setFormData(newSelected)
                                    }} >
                                        <div className='font-[700] mt-[-1px] mr-[-1px]'>-</div>
                                    </div>
                                    <div>{assessmentObj.name} <span className='text-[#949494]'>| {assessmentObj.templateType || assessmentObj?.type}</span></div>
                                </div>
                            )}
                        </div>
                        <div className="flex flex-col mb-4">
                            <div onClick={() => {
                                if (formData.length === 0) {
                                    alert('Please select at least one template')
                                    return
                                }
                                setShowSelectTemplatePopup(false)
                            }} type="submit" className='flex flex-row items-center justify-center bg-[#00202A] text-[#63BDFF] border-none h-[40px] rounded-full cursor-pointer mt-[32px]'>Confirm</div>
                        </div>
                    </div>
                </div>
            }
            {isLoading && <LoadingPage />}
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Screen)